module.exports = __webpack_public_path__ + "static/media/nextMobile.c870ca53.svg";